// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3II2x","log":"ModalInventoryLogs_log__2bnOp","date":"ModalInventoryLogs_date__25ad4","userName":"ModalInventoryLogs_userName__2eroZ"};